import type { CSSProperties } from 'react';
import type { SceneConfig } from './planetSections';
import './cinematic-frame.css';

export interface CinematicFrameProps {
  scene: SceneConfig;
  hidden?: boolean;
}

export function CinematicFrame({ scene, hidden = false }: CinematicFrameProps) {
  const style = {
    '--cinema-bar': `${scene.cinemaBarVh}vh`,
    '--cinema-bar-mobile': `${scene.cinemaBarMobileVh}svh`,
  } as CSSProperties;

  return (
    <div
      className={['cinematic-frame', hidden ? 'is-hidden' : '']
        .filter(Boolean)
        .join(' ')}
      style={style}
      aria-hidden="true"
    >
      <span className="cinematic-frame__bar cinematic-frame__bar--top" />
      <span className="cinematic-frame__bar cinematic-frame__bar--bottom" />
      <span className="cinematic-frame__vignette" />
    </div>
  );
}

export default CinematicFrame;
